module.exports = __webpack_public_path__ + "static/icon-d56d86c958ea9d3cade042730588a13a.ico";